enum GeometryType {
  CONTOUR = 'contour',
}

export default GeometryType;
